import styled from "@emotion/styled";

export const GridWrapper = styled.div`
  display: grid;
  width: 100%;
  gap: ${({ theme }) => theme.space.space8};
  grid-column: span 3;
  grid-auto-rows: max-content;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }

  .image-container {
    position: relative;
    width: 100%;
    aspect-ratio: 3 / 4;
    overflow: hidden;
    cursor: pointer;

    &[data-loaded="false"] {
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${({ theme }) => theme.colors.tone.marble};
        animation: progress 2s ease infinite;
      }

      img {
        opacity: 0;
      }
    }

    img {
      object-fit: cover;
      transform: scale(1);
      opacity: 1;
      transition: transform 350ms ease-in-out, opacity 350ms ease-in-out;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  &.two-by-two {
    grid-template-columns: repeat(2, 1fr);
  }

  &.two-by-one {
    grid-template-columns: repeat(2, 1fr);

    .image-container:nth-child(3) {
      grid-column: span 2;
    }
  }

  &.two-by-three {
    grid-template-columns: repeat(6, 1fr);

    .image-container {
      grid-column: span 2;
    }

    .image-container:nth-child(-n + 2),
    .image-container:nth-last-child(-n + 2) {
      grid-column: span 3;
    }

    .image-container:nth-child(6) {
      grid-column: span 6;
    }
  }

  @keyframes progress {
    0% {
      opacity: 0.8;
    }
    50% {
      opacity: 0.2;
    }
    100% {
      opacity: 0.8;
    }
  }
`;
